import { useEffect, useState, type CSSProperties } from 'react';
import { createPortal } from 'react-dom';
import { useLocation } from 'react-router-dom';
import { useOfferToastStore } from '../../../../redux/offers/offerHooks';

const OFFERS_BASE = '/offers';

function useOffersRouteActive(): boolean {
  const { pathname } = useLocation();
  return pathname.startsWith(OFFERS_BASE);
}

export default function OffersToastContainer() {
  const { toasts, removeToast } = useOfferToastStore();
  const active = useOffersRouteActive();
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    setMounted(true);
  }, []);

  if (!mounted || !active || !toasts.length) return null;

  const TYPE_BG: Record<string, string> = {
    success: '#6F6F6F',
    info: '#6F6F6F',
    error: '#E52333',
    warning: '#ff9800',
  };

  const wrap: CSSProperties = {
    position: 'fixed',
    left: '50%',
    bottom: 40,
    transform: 'translateX(-50%)',
    zIndex: 2147483000,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: 12,
    pointerEvents: 'none',
    maxWidth: 'min(560px, calc(100vw - 32px))',
  };

  return createPortal(
    <div style={wrap} aria-live="polite">
      {toasts.map((t) => {
        const bg = TYPE_BG[t.type] ?? TYPE_BG.info;
        return (
          <div
            key={t.id}
            style={{
              pointerEvents: 'auto',
              minWidth: 300,
              maxWidth: '100%',
              borderRadius: 30,
              background: bg,
              color: '#FFFFFF',
              padding: '12px 44px 12px 20px',
              boxShadow: '0 4px 20px rgba(0,0,0,0.18)',
              display: 'flex',
              alignItems: 'center',
              gap: 10,
              fontSize: 14,
              fontWeight: 500,
              fontFamily: 'var(--font-primary, "DM Sans", sans-serif)',
              lineHeight: 1.35,
              position: 'relative',
            }}
          >
            <span style={{ flex: 1, textAlign: 'center' }}>{t.message}</span>
            <button
              type="button"
              onClick={() => removeToast(t.id)}
              style={{
                position: 'absolute',
                right: 12,
                top: '50%',
                transform: 'translateY(-50%)',
                border: 'none',
                background: 'rgba(255,255,255,0.22)',
                color: '#FFFFFF',
                cursor: 'pointer',
                fontSize: 16,
                lineHeight: 1,
                width: 26,
                height: 26,
                padding: 0,
                borderRadius: 13,
                display: 'inline-flex',
                alignItems: 'center',
                justifyContent: 'center',
              }}
              aria-label="Close toast"
            >
              ×
            </button>
          </div>
        );
      })}
    </div>,
    document.body,
  );
}
